import React from 'react'
import Link from 'react-router-dom/Link'
import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../../../../src/ducks/site/site'
import { bindActionCreators } from 'redux'
import { routes } from '../../../../constants/routes.constants'
import { Footer, Question, ClickHere, BigCard, Message } from './styles.style'

class MuviCardZone extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { logged, setMenuOptionPath } = this.props
		const { ENTRAR, MUVICARD_CADASTRO, MEU_CARTAO } = routes
		return (
			<Footer className="muvicard-footer">
				<div className="customer-area">
					<div className="customer">
						<Question>Já é cliente Muvicard?</Question>
						<ClickHere>
							Acesse a área do cliente{' '}
							<Link to={`${MEU_CARTAO}`} title="Área do cliente">
								<span
									onClick={() => {
										setMenuOptionPath(`${MEU_CARTAO}`)
									}}>
									aqui
								</span>
							</Link>
						</ClickHere>
						<BigCard />
						<Message>
							<Link
								to={`${MUVICARD_CADASTRO}`}
								title="Realizar cadastro do cartão Muvicard">
								<span
									onClick={() => {
										setMenuOptionPath(`${MUVICARD_CADASTRO}`)
									}}>
									Fazer meu cartão muvicard
								</span>
							</Link>
						</Message>
					</div>
				</div>
			</Footer>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setMenuOptionPath: SiteCreators.menuOptionPath,
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(MuviCardZone)
